import dayjs from 'dayjs';

const compareByDate = (a: string, b: string): number => {
  if (dayjs(b).isBefore(dayjs(a))) {
    return -1;
  }
  if (dayjs(a).isBefore(dayjs(b))) {
    return 1;
  }

  return 0;
};

export default compareByDate;
